<template>
    <b-modal
        :title="note.title + ' - ' + $moment(note.customDate).format('MM/DD/YYYY')"
        header-bg-variant="success"
        header-text-variant="light"
        size="lg"
        :visible="true"
        centered
        @hide="modalClose"
        @ok="updateNote"
    >
      <b-row>
        <b-col>
          <b-form-group label-class='addpersonlabel' label='Date' label-for="date" :horizontal='false'>
            <datepicker
              name="date"
              input-class="form-control-lg"
              initial-view="day"
              v-model="note.customDate"
              placeholder="Select Date"
              :format="this.$dateFormatter"
              :disabled-dates="{ from: new Date() }"
              clear-button
            />
          </b-form-group>
          <b-form-group
            label="Title"
            label-class='addpersonlabel'
            label-for="title"
          >
            <b-form-input
              size="lg"
              type='text'
              name="title"
              v-model="note.title"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            label="Type"
          >
            <v-select
              :options="noteTypes"
              label="title"
              v-model="note.noteType"
              :reduce="noteType => noteType.value"
              placeholder="Type to Search"
            >
            </v-select>
          </b-form-group>
          <b-form-textarea
            rows="10"
            class="mt-3"
            placeholder="Enter Note"
            name="note"
            v-model="note.note"
          >
          </b-form-textarea>
        </b-col>

        <b-col :key="componentKey">
          <ShareNoteList
            :noteId="note.id"
            :noteOrganizationOwner="note.organizationOwner.id"
            :personId="note.person"
          ></ShareNoteList>

          <b-card no-body>
            <b-card-body>
              <p class="card-text">
                <small class="text-muted text-uppercase font-weight-bold">First Recorded</small>
                <br/>
                <small class="text-muted"><b> on: </b> {{ (note.createdAt/1000) | unixToHuman }}
                  <div v-if="_.isObject(note.createdBy)">
                    <b> by: </b> {{ _.get(note, 'createdBy.emailAddress', '') }}
                  </div>
                </small>
              </p>
              <p class="card-text">
                <small class="text-muted text-uppercase font-weight-bold">Last Updated</small>
                <br/>
                <small class="text-muted"><b> on: </b> {{ getUpdatedAt }}
                  <div v-if="_.isObject(note.updatedBy)">
                    <b> by: </b> {{ _.get(note, 'updatedBy.emailAddress', '') }}
                  </div>
                </small>
              </p>
              <p class="card-text">
                <small class="text-muted text-uppercase font-weight-bold">Current Record Owner</small>
                <br/>
                <small class="text-muted"><b> by: </b> {{ _.get(note, 'organizationOwner.title') }} </small>
              </p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <template #modal-footer>
       <div class="w-100">
          <b-button
            :disabled="!isAllowedToCreateOrEditPerson"
            variant="primary"
            size="sm"
            class="float-right"
            @click="updateNote"
          >
            Update
          </b-button>
          <b-button
            variant="link"
            size="sm"
            class="float-right"
            @click="modalClose"
          >
            Cancel
          </b-button>
        </div>
      </template>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ShareNoteList from '@/components/Note/ShareNoteList'
const moment = require('moment')

export default {
  name: 'view-note-modal',
  props: {
    note: {
      type: Object,
      default () {
        return {}
      }
    },
    isAllowedToCreateOrEditPerson: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ShareNoteList
  },
  computed: {
    ...mapGetters({
      userCurrentContext: 'userCurrentContext', // Passing user context to determine if they have isOrgAdmin
      notes: 'shareNoteRecords',
      noteTypes: 'getNoteTypes',
      editNote: 'getEditNote'
    }),
    getUpdatedAt () {
      let updatedAt = this.note.updatedAt
      if (this.editNote.id === this.note.id) {
        updatedAt = this.editNote.updatedAt || this.note.updatedAt
      }
      return moment.unix(updatedAt / 1000).format('MM/DD/YYYY hh:mm')
    }
  },
  data: function () {
    return {
      componentKey: 0,
      organizationOwner: 0
    }
  },
  watch: {
    notes: function (newValue, oldValue) {
      if (newValue) {
        this.organizationOwner = newValue[0].snote.organizationOwner
      }
    }
  },
  methods: {
    modalClose: function () {
      this.$emit('modalClose')
    },
    forceRerender: function () {
      this.componentKey += 1
    },
    updateNote: function () {
      this.$store
        .dispatch(
          'updateNote',
          {
            id: this.note.id,
            title: this.note.title,
            noteType: this.note.noteType,
            note: this.note.note
          }
        )
      this.$emit('modalClose')
    }
  },
  created () {
    this.$store.dispatch('addViewNoteLog', {
      id: this.note.id
    })
  },
  mounted () {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/t1/ViewNoteModal.vue